<script>
  export let currrentStep = 3;
  let step3var1, step3var2;
  let step3error;
  let refreshing = false;
  let resetSuccess = false;
  let resetFail = false;
  
  $: passwordChoice = step3var1;
  $: passwordChoiceConfirm = step3var2;
  $: passwordMatches = false;

  let cx = {
    number: false,
    lowercase:false,
    uppercase:false,
    symbol:false,
    minlength:false
  }

  let cxCombos = 0;

  let cxFinal = false;

  const complexityCheck = (event) => {
    let lowerChars = /[a-z]/;
		let upperChars = /[A-Z]/;
		let numChars = /[0-9]/;
    let symChars = /~|!|@|#|\$|%|\^|&|\*|_|-|\+|\=|`|\||\\|\(|\)|\{|\}|\[|\]|:|\;|\"|\'|<|>|,|\.|\?|\//
    if(passwordChoice.length>1){
      cx.lowercase =  passwordChoice.match(lowerChars)?.length > 0;
      cx.uppercase =  passwordChoice.match(upperChars)?.length > 0;
      cx.number =  passwordChoice.match(numChars)?.length > 0;
      cx.symbol = passwordChoice.match(symChars)?.length > 0;
      cx.minlength =  passwordChoice.length > 7;
    }

    cxCombos = 0;
    cxCombos += cx.number; 
    cxCombos += cx.lowercase; 
    cxCombos += cx.uppercase; 
    cxCombos += cx.symbol; 

    cxFinal = (cxCombos > 2 && cx.minlength)

    console.log("cx\n", cx);
    console.log("cxCombos\n", cxCombos);
    console.log("cxFinal\n", cxFinal);

  };

  const confirmationCheck = (event) => {

    // if (event.keyCode === 13 || event.key === 'Enter') {
    //   step3();
    // }

  };

  const step3 = async () => {
    step3error = false;
    refreshing = true;
    if (cxFinal && step3var1 == step3var2) {
      getData();
    } else {
      step3error = true;
      // step3var1 = "";
      // step3var2 = "";
      document.querySelector("#newcreds").focus();
      refreshing = false;
    }
  };

  const apiURL = '/password/reset/shhhh';

  const getData = async () => {
      const res = await fetch(apiURL,
                        {
                          method: 'POST',
                          headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                          },
                          body: JSON.stringify({a: step3var1})
                        });
      
      if (!res.ok && res.status == '302') {
        console.log(res);
        window.location.reload(true);
      } else if (!res.ok && res.status == '404') {
        step3error = true;
        step3var1 = "";
        step3var2 = "";
        document.querySelector("#newcreds").focus();
      } else if (!res.ok && res.status == '419') {
        step3error = false;
        step3var1 = "";
        step3var2 = "";
        resetSuccess = false;
        resetFail = true;
      } else {
        resetSuccess = true;
        resetFail = false;
      };
      refreshing = false;
  }

</script>

<div class="card-body">
  <div class="alert alert-danger" class:hide={!step3error || cxFinal || resetSuccess || resetFail}>
    Errors with password
  </div>
  <div class="alert alert-warning" class:hide={!step3error || cxFinal || resetSuccess || resetFail} >
    <ul>
      <li class:hide={cx.minlength}>Password must be at least eight (8) characters long</li>
      <li class:hide={cx.lowercase}>Password must contain at least one (1) Lowercase Character</li>
      <li class:hide={cx.uppercase}>Password must contain at least one (1) Uppercase Character</li>
      <li class:hide={cx.number || cx.symbol}>
        Password must contain at least one (1) number or special character
      </li>
      <li class:hide={step3var1 == step3var2}>Provided passwords did not match</li>

    </ul>
  </div>
  <ol class:hide={step3error ||resetSuccess || resetFail}>
    <li>
      Please note that your new password
      <ul>
        <li class:text-success={cx.minlength}>must be more than 8 characters long</li>
        <li class:text-success={cx.uppercase}>must contain a capital letter,</li>
        <li class:text-success={cx.number}>must contain a number and</li>
        <li class:text-success={cx.symbol}>must contain a symbol</li>
      </ul>
    </li>
    <li>Please do not use a previous password or it will be rejected.</li>
  </ol>

<form class:hide={resetSuccess || resetFail} accept-charset="utf-8">
  <div class="row">
    <div class="mb-3 col-auto">
      <label for="newcreds" class="col-form-label">New Password</label>
      <input
        type="password"
        class="form-control"
        id="newcreds"
        autocomplete="off"
        bind:value={step3var1}
        on:keyup={complexityCheck}
        autofocus
      />
    </div>
  </div>

  <div class="row">
    <div class="mb-3 col-auto">
      <label for="newcredsagain" class="col-form-label">Verify New Password</label>

      <input
        type="password"
        class="form-control"
        id="newcredsagain"
        autocomplete="off"
        on:keyup={confirmationCheck}
        bind:value={step3var2}
      />
    </div>
  </div>


  
  <div class="mb-3">
    <button
      type="submit"
      class="btn btn-secondary"
      on:click|preventDefault={step3}
    >
      {#if refreshing}
        <span><i class="fas fa-spinner fa-spin" /></span>
      {:else}
        <span>OK</span>
      {/if}
    </button>
    <a href="/password/reset" class="btn btn-outline-secondary">Cancel</a>
  </div>
</form>

  <div class="alert alert-success" class:hide={!resetSuccess} class:show={resetSuccess}>
    Your password has been reset to these targets UWI, and e-mailed to you
    <hr>
    <a href="/" class="btn btn-secondary me-4">Sign In</a>
  </div>

  <div class="alert alert-danger" class:hide={!resetFail} class:show={resetFail}>
    Your password could not be reset at this time, please ensure your password was not used before.
    <hr>
    <a href="/password/index/reset" class="btn btn-secondary me-4">Back</a>
  </div>
</div>

<style>
</style>
